export default __webpack_public_path__ + "static/media/large.3a3bc4fd.jpg";